(ns frontend.view.settings.sys-admin.tenant.users.view
  (:require
   [common.localization :as loc]
   [reagent.core :as r]
   [common.dates :as dt]
   [frontend.view.reports.events :as events]))

(def headers
  [:tenant-users/first-name
   :tenant-users/last-name
   :tenant-users/email
   :tenant-users/account-id
   :tenant-users/dfm
   :tenant-users/reporting
   :tenant-users/rights
   :tenant-users/status
   :tenant-users/team-role
   :tenant-users/last-session-start])

(defn table-header
  [header]
  [:th (loc/tr header)])

(defn table-row
  [{:tenant-users/keys [first-name last-name email account-id dfm reporting rights status team-role
                        last-session-start]}]
  (let [team-role (or team-role :none)]
    [:tr 
     {:class "*:whitespace-nowrap *:px-2 *:py-3 *:text-sm *:text-base-light-text even:bg-base-regular"}
     [:td first-name]
     [:td last-name]
     [:td email]
     [:td account-id]
     [:td (loc/tr dfm)]
     [:td (loc/tr reporting)]
     [:td rights]
     [:td (loc/tr status)]
     [:td (loc/tr (keyword "team-role-result" team-role))]
     [:td
      (when (some? last-session-start)
        (-> (dt/date last-session-start)
            (dt/format {:pattern (loc/tr :date-format)})))]]))

(defn header-key
  [v]
  (str "tenant-users-table-header-" (name v)))

(defn table-row-key
  [{:keys [tenant-users/account-id]}]
  (str "tenant-users-table-item-" account-id))

(defn render
  [id]
  (let [data (events/get-data! :tenant-users {:tenant-id id})]
    [:div 
     {:class "border border-solid border-base-light-border-paler rounded"}
     [:div 
      {:class "p-3 flex justify-between items-center border-b border-solid border-base-light-border-paler"}
       [:h2
        {:class "font-bold"}
        (loc/tr :tenant-users/card-header)]]
     [:div
      {:class "p-4 w-full"}
      [:table
       {:class-name "min-w-full divide-y divide-solid divide-base-regular-border-paler"}
       [:thead
        [:tr
         {:class "*:py-3 *:px-2 *:text-left *:text-sm *:font-bold *:text-base-light-text"}
         (for [item headers]
           ^{:key (header-key item)}
           [table-header item])]]
       [:tbody
        (for [item data]
          ^{:key (table-row-key item)}
          [table-row item])]]]]))

(defn view
  [{:keys [db/id]}]
  (r/create-class
   {:component-did-mount    (partial events/fetch-data! [:tenant-users {:tenant-id id}])
    :component-will-unmount (partial events/delete-data! [:tenant-users {:tenant-id id}])
    :reagent-render         (partial render id)}))
